import { format } from "date-fns";

import { calculateAge } from "@utils/datetime";

export const DOB_INPUT_MAX_LENGTH = 10;

export function formatDobInput(value: string): string {
  const digits = value.replace(/\D/g, "");
  if (digits.length <= 2) {
    return digits;
  }
  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  }
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4, 8)}`;
}

export function parseDobInputToLocalNoon(dateStr: string): Date | null {
  const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  if (!dateRegex.test(dateStr)) {
    return null;
  }

  const [month, day, year] = dateStr.split("/").map(Number);
  const date = new Date(year, month - 1, day);

  if (
    date.getMonth() !== month - 1 ||
    date.getDate() !== day ||
    date.getFullYear() !== year
  ) {
    return null;
  }

  return new Date(year, month - 1, day, 12, 0, 0);
}

export function formatIsoDobForDisplay(storedDate?: string | null): string {
  if (!storedDate) {
    return "";
  }
  const date = new Date(storedDate);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return format(date, "MM/dd/yyyy");
}

/**
 * Survey answers sometimes store DOB as an ISO string or a `Date` (e.g. hydration edge cases).
 */
export function surveyDobValueToIsoString(
  value: string | Date | undefined | null
): string | undefined {
  if (value == null) {
    return undefined;
  }
  if (typeof value === "string") {
    return value;
  }
  if (value instanceof Date) {
    return value.toISOString();
  }
  return undefined;
}

export function isLocalDateOnOrBeforeEndOfToday(date: Date): boolean {
  const today = new Date();
  const endOfToday = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    23,
    59,
    59,
    999
  );
  return date.getTime() <= endOfToday.getTime();
}

export function isDobAgeBetweenInclusive(
  date: Date,
  minAge: number,
  maxAge: number
): boolean {
  const age = calculateAge(date);
  return age >= minAge && age <= maxAge;
}
